import React, { useState } from 'react';
import { Quote, Star, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import { testimonials, restaurantInfo } from '../../data/mock';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold tracking-wider text-[#C67C4E] uppercase mb-4">
            Testimonials
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-[#1B4332] mb-6">
            What You&apos;ve Been Saying
          </h2>
        </div>

        {/* Testimonial Card */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-[#1B4332] rounded-3xl p-8 sm:p-12 relative">
            <Quote size={60} className="text-white/10 absolute top-8 left-8" />
            
            <div className="relative z-10">
              {/* Stars */}
              <div className="flex justify-center mb-6">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={`hero-star-${i}`}
                    size={24}
                    className="text-[#C67C4E] fill-[#C67C4E]"
                  />
                ))}
              </div>

              {/* Quote */}
              <blockquote className="font-serif text-2xl sm:text-3xl text-center text-white mb-8 leading-relaxed">
                &ldquo;{testimonials[currentIndex].text}&rdquo;
              </blockquote>

              {/* Author */}
              <div className="text-center">
                <p className="font-semibold text-lg text-[#C67C4E]">
                  {testimonials[currentIndex].name}
                </p>
                <p className="text-white/60">
                  Via {testimonials[currentIndex].source}
                </p>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex justify-center gap-4 mt-8">
              <Button
                variant="outline"
                size="icon"
                onClick={prevTestimonial}
                className="rounded-full border-white/30 text-white hover:bg-white hover:text-[#1B4332]"
              >
                <ChevronLeft size={20} />
              </Button>
              <Button
                variant="outline"
                size="icon"
                onClick={nextTestimonial}
                className="rounded-full border-white/30 text-white hover:bg-white hover:text-[#1B4332]"
              >
                <ChevronRight size={20} />
              </Button>
            </div>

            {/* Dots */}
            <div className="flex justify-center gap-2 mt-6">
              {testimonials.map((tst, i) => (
                <button
                  key={tst.id || tst.name || `dot-${i}`}
                  onClick={() => setCurrentIndex(i)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    i === currentIndex
                      ? 'bg-[#C67C4E] w-8'
                      : 'bg-white/30'
                  }`}
                  aria-label={`Go to testimonial ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Reviews Links */}
        <div className="flex flex-wrap justify-center gap-6 mt-12">
          <a
            href={restaurantInfo.googleReviewsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-[#F5F0E8] rounded-full px-6 py-3 hover:shadow-lg transition-shadow"
          >
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={`footer-star-${i}`}
                  size={16}
                  className="text-[#C67C4E] fill-[#C67C4E]"
                />
              ))}
            </div>
            <span className="font-medium text-[#1B4332]">
              View Google Reviews
            </span>
          </a>
          <a
            href={restaurantInfo.tripAdvisorUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-[#F5F0E8] rounded-full px-6 py-3 hover:shadow-lg transition-shadow"
          >
            <span className="font-medium text-[#1B4332]">
              View on TripAdvisor
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
